import React from 'react';
import connect from 'react-redux/es/connect/connect';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import { saveApiTabSelection } from '../../stores/ApiTabSelectionParam/ApiTabSelectionParamActions';

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
});

const ApiTab = (props) => {

  const classes = useStyles();
  const { apiTabSelection, saveApiTabSelection } = props;

  return (
    <Paper className={classes.root}>
      <Tabs
        TabIndicatorProps={{style: {border: '2px solid #702F8A', background:'#702F8A'}}}
        value={apiTabSelection}
        onChange={(_event, newEvent) => saveApiTabSelection(newEvent)}
        centered
      >
        <Tab disableRipple style={{ fontFamily: 'OpenSans, sans-serif', textRendering: 'geometricprecision', fontSize: "17px", fontWeight: apiTabSelection === "Overview" ? "600" : "300", color: apiTabSelection === "Overview" ? "#702F8A" : "unset", outline: "none"}} value={"Overview"} label="Overview" />
        <Tab disableRipple style={{ fontFamily: 'OpenSans, sans-serif', textRendering: 'geometricprecision', fontSize: "17px", fontWeight: apiTabSelection === "Documentation" ? "600" : "300", color: apiTabSelection === "Documentation" ? "#702F8A" : "unset", outline: "none"}} value={"Documentation"} label="Documentation" />
        <Tab disableRipple style={{ fontFamily: 'OpenSans, sans-serif', textRendering: 'geometricprecision', fontSize: "17px", fontWeight: apiTabSelection === "Faq" ? "600" : "300", color: apiTabSelection === "Faq" ? "#702F8A" : "unset", outline: "none"}} value={"Faq"} label="FAQ" />
      </Tabs>
    </Paper>
  );
}

//// JS REDUX
const mapStateToProps = (state) => ({
  apiTabSelection: state.apiTabSelectionParam.apiTabSelection,
});

const mapDispatchToProps = {
  saveApiTabSelection,
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiTab);